"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genProductPriceLabel = exports.genProductPriceAgeLabel = void 0;
const genProductPriceAgeLabel = ({ minAge, maxAge }, options) => {
    if (!(minAge || maxAge))
        return `All ages`;
    if (options?.variant === "long")
        return genProductPriceAgeLongLabel({ minAge, maxAge });
    if (maxAge === null)
        return `Age ${minAge}+`;
    if (minAge === maxAge)
        return `Age ${minAge}`;
    return `Age ${minAge}-${maxAge}`;
};
exports.genProductPriceAgeLabel = genProductPriceAgeLabel;
const genProductPriceAgeLongLabel = ({ minAge, maxAge }) => {
    if (!maxAge)
        return `Ages ${minAge} or above`;
    if (minAge === 0)
        return `Under ${maxAge + 1}`;
    if (minAge === maxAge)
        return `Age ${minAge}`;
    return `Ages ${minAge} - ${maxAge}`;
};
function genProductPriceLabel({ minAge, maxAge, tags }, options) {
    const { addTagParentheses = true, variant = "short" } = options ?? {};
    const ageLabel = (0, exports.genProductPriceAgeLabel)({
        minAge,
        maxAge,
    }, { variant });
    const tagLabel = (tags ?? [])
        .map((tag) => (typeof tag === "string" ? tag : tag.tag))
        .join(", ");
    return tagLabel
        ? addTagParentheses
            ? `${ageLabel} (${tagLabel})`
            : `${ageLabel} ${tagLabel}`
        : ageLabel;
}
exports.genProductPriceLabel = genProductPriceLabel;
//# sourceMappingURL=genProductPriceLabel.js.map